import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { bindActionCreators } from 'redux';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import IMG_ALL_CLIENTS from 'assets/images/marketing-all-clients.svg';
import IMG_BIRTHDAY from 'assets/images/marketing-birthday.svg';
import IMG_LOST_CLIENTS from 'assets/images/marketing-lost-clients.svg';
import IMG_NEW_CLIENTS from 'assets/images/marketing-new-clients.svg';
import IMG_PATCH_TEST_CLIENTS from 'assets/images/marketing-patch-test-clients.png';
import IMG_REGULAR_CLIENTS from 'assets/images/marketing-regular-clients.svg';
import IMG_REVIEW from 'assets/images/marketing-review.svg';
import IMG_UPCOMING_CLIENTS from 'assets/images/marketing-upcoming-clients.svg';
import { useTranslation } from 'providers/GILT.provider';

import { getAllClientsCount } from 'clientCommunications/actions';
import { determineMarketingBucketList } from 'clientCommunications/constants';
import { trackEvent } from 'tracking/actions';

import 'styles/clientcommunications/index.scss';

const MarketingLayout = ({ fetchStylistsBySalon, getAllClientsCount, salonId, countClients, trackEvent, history }) => {
  const { t } = useTranslation();

  useEffect(() => {
    fetchStylistsBySalon(salonId);
    getAllClientsCount(salonId);
    window.scrollTo(0, 0);
  }, [fetchStylistsBySalon, getAllClientsCount, salonId]);

  const onImageUpload = (bucketId) => {
    switch (bucketId) {
      case 1:
        return IMG_ALL_CLIENTS;
      case 2:
        return IMG_LOST_CLIENTS;
      case 3:
        return IMG_LOST_CLIENTS;
      case 4:
        return IMG_PATCH_TEST_CLIENTS;
      case 5:
        return IMG_NEW_CLIENTS;
      case 6:
        return IMG_BIRTHDAY;
      case 7:
        return IMG_REVIEW; // Last week
      case 8:
        return IMG_UPCOMING_CLIENTS; // Next week
      case 9:
        return IMG_REGULAR_CLIENTS;
      case 10:
        return IMG_ALL_CLIENTS;
      case 11:
        return IMG_ALL_CLIENTS;

      default:
        return IMG_ALL_CLIENTS;
    }
  };

  const countClientInBuckets = (bucketId) => {
    const {
      clients_with_phones_count: phoneClient,
      lost_clients_count: lostClient,
      duplicate_clients_count: duplicateClients,
      birthday_clients_count: birthdayClient,
      active_clients_count: regularClient,
      recent_clients_count: lastWeekClient,
      upcoming_clients_count: nextWeekClient,
      first_time_clients_count: newClient,
      invalid_patch_test_clients_count: pachTestClient,
      all_clients_count: allClient,
      clients_canceled_last_month_count: cancelledClients,
    } = countClients;

    switch (bucketId) {
      case 1:
        return phoneClient;
      case 2:
        return lostClient;
      case 3:
        return cancelledClients;
      case 4:
        return pachTestClient;
      case 5:
        return newClient;
      case 6:
        return birthdayClient;
      case 7:
        return lastWeekClient;
      case 8:
        return nextWeekClient;
      case 9:
        return regularClient;
      case 10:
        return duplicateClients;
      case 11:
        return allClient;

      default:
        return 0;
    }
  };

  const marketingBucketList = determineMarketingBucketList(t);

  return (
    <div className="page-layout">
      <h2 className="general-title-marketing">{t('marketing.heading')}</h2>
      <div className="marketing-container">
        {marketingBucketList.map(({ apiSuffix, description, id, information, question, title }) => (
          <div className="list-grid-item" key={id}>
            <div
              className="bucket-text"
              role="button"
              tabIndex={0}
              onClick={() => {
                let eventName;
                switch (apiSuffix) {
                  case 'withphone':
                    eventName = 'show_phone_clients';
                    break;
                  case 'lost':
                    eventName = 'show_lost_clients';
                    break;
                  case 'duplicates':
                    eventName = 'show_duplicates_clients';
                    break;
                  case 'upcoming':
                    eventName = 'show_next7d_clients';
                    break;
                  case 'invalid_patch_test':
                    eventName = 'show_pachtest_clients';
                    break;
                  case 'active':
                    eventName = 'show_active_clients';
                    break;
                  case 'birthday':
                    eventName = 'show_bday_clients';
                    break;
                  case 'first':
                    eventName = 'show_new_clients';
                    break;
                  case 'recent':
                    eventName = 'show_last7d_clients';
                    break;
                  case 'list':
                    eventName = 'show_all_clients';
                    break;
                  case 'cancelations':
                    eventName = 'cancelled_clients';
                    break;
                  default:
                    eventName = '';
                }
                trackEvent(eventName);
                if (apiSuffix === 'duplicates') {
                  history.push(`/salon/${salonId}/communications/mergeclients`);
                } else {
                  history.push(`/salon/${salonId}/communications/clients/${apiSuffix}`);
                }
              }}
            >
              <div className="primary-text">{title}</div>
              <div className="client-count">
                {isEmpty(countClients) ? (
                  <div className="spinner-container">
                    <div className="load-spinner" />
                  </div>
                ) : (
                  <div>{countClientInBuckets(id)}</div>
                )}
              </div>

              <div className="supporting-text">
                <span>{description}</span>
                <span> {question}</span>
              </div>
            </div>
            <div className="rectangle">
              <img className="img_test" src={onImageUpload(id)} alt="" />
              <div className="img-shadow" />
            </div>
            <div className="prevent-click" />
            <div className="client-info">
              <div className="info-icon">
                <span className="tooltip">
                  <div className="tooltip-centered">{information}</div>
                </span>
              </div>
              <span className="client-info-span">{t('marketing.calculationInfo')}</span>
            </div>
            <div className="prevent-click" />
            <button
              type="button"
              className="btn btn-violet show-me-clients-btn"
              onClick={() => {
                let eventName;
                switch (apiSuffix) {
                  case 'withphone':
                    eventName = 'show_phone_clients';
                    break;
                  case 'lost':
                    eventName = 'show_lost_clients';
                    break;
                  case 'duplicates':
                    eventName = 'show_duplicates_clients';
                    break;
                  case 'upcoming':
                    eventName = 'show_next7d_clients';
                    break;
                  case 'invalid_patch_test':
                    eventName = 'show_pachtest_clients';
                    break;
                  case 'active':
                    eventName = 'show_active_clients';
                    break;
                  case 'birthday':
                    eventName = 'show_bday_clients';
                    break;
                  case 'first':
                    eventName = 'show_new_clients';
                    break;
                  case 'recent':
                    eventName = 'show_last7d_clients';
                    break;
                  case 'list':
                    eventName = 'show_all_clients';
                    break;
                  case 'cancelations':
                    eventName = 'cancelled_clients';
                    break;
                  default:
                    eventName = '';
                }
                trackEvent(eventName);
                if (apiSuffix === 'duplicates') {
                  history.push(`/salon/${salonId}/communications/mergeclients`);
                } else {
                  history.push(`/salon/${salonId}/communications/clients/${apiSuffix}`);
                }
              }}
            >
              <span className="show-me-clients-txt">{apiSuffix === 'duplicates' ? t('marketing.mergeDupes') : t('marketing.showClients')}</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  salonId: state.currentSalon.id,
  countClients: state.clientCommunications.countClients,
  isFetchingCount: state.clientCommunications.isFetchingCount,
  stylistList: state.currentSalon.stylistList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      trackEvent,
      getAllClientsCount,
      fetchStylistsBySalon,
    },
    dispatch,
  );

const MarketingLayoutHoc = connect(mapStateToProps, mapDispatchToProps)(MarketingLayout);

export default MarketingLayoutHoc;
